import { AuthorizedUser } from './types';
import { UserPermissions } from '@src/utils/enums';

/**
 * Helper functions related to request permission logic
 * - Determines if current user can sign a request
 * - Finds the request owner
 * Used in certify/sign/submit components
 */

export const getRequestOwner = (authorizedUsers: AuthorizedUser[] = []) =>
  authorizedUsers.find((user) => user.permission === UserPermissions.Owner);
